import { client } from '@/api/backoffice-api';
import AppConfig from '@/utils/app-config.mjs';
export interface DealerActionList<T> {
  items: T[];
  meta: {
    hasMore: boolean,
    offset: string | number,
    count: number
  }
}
export async function generateAPI() {
  const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/store/api-key`,
    { timeout: 30000 }
  );
  return response.data;
}
export async function fetchAPI() {
  const response = await client.get(
    `${AppConfig.backOfficeApiBaseURL}/store/config`,
    { timeout: 30000 }
  );
  return response.data;
}
export async function refreshAPI() {
  const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/store/api-key/re-generate`,
    { timeout: 30000 }
  );
  return response.data;
}
export async function deleteAPI() {
  const response = await client.delete(
    `${AppConfig.backOfficeApiBaseURL}/store/api-key`,
    { timeout: 30000 }
  );
  return response.data;
}
export async function automateTransferWorkflowApi(is_pending_workflow: boolean){
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/enable-pending-transfers`,
    {is_pending_workflow},
    { timeout: 30000 }
  );
  return response.data;
}

